import { render, staticRenderFns } from "./ResourcePricingInfo.vue?vue&type=template&id=e7a36824"
import script from "./ResourcePricingInfo.vue?vue&type=script&lang=js"
export * from "./ResourcePricingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports